import { createFileRoute, redirect } from "@tanstack/react-router";
import { arrivingStepIn } from "@/client/components/arriving";
import {
  ArrivingFailed,
  ArrivingLayout,
  ArrivingPending,
} from "@/client/components/arriving-layout";
import { pageTitle } from "@/client/lib/page-title";
import { PENDING_MS } from "@/client/lib/pending";
import { sessionQuery } from "@/client/lib/session";
import { CodeStep, SignUpStep } from "@/features/identity/components/sign-up";
import { signUpSearch } from "@/features/identity/search";
import { useSignUpFlow } from "@/features/identity/use-sign-up-flow";

export const Route = createFileRoute("/sign-up")({
  pendingMs: PENDING_MS,
  pendingComponent: ArrivingPending,
  errorComponent: ArrivingFailed,
  validateSearch: signUpSearch,
  beforeLoad: async ({ context, search }) => {
    const session = await context.queryClient.ensureQueryData(sessionQuery);
    if (session.signedIn) throw redirect({ href: search.redirect });
  },
  head: async () => {
    const { identityCopy } = await import("@/features/identity/copy");
    return { meta: [{ title: pageTitle(identityCopy.signUp.tab) }] };
  },
  component: SignUp,
});

function SignUp() {
  const { redirect: destination, email, verify } = Route.useSearch();
  const flow = useSignUpFlow(destination, email, verify);

  return (
    <ArrivingLayout>
      <div key={flow.state.step} className={arrivingStepIn}>
        {flow.state.step === "code" ? (
          <CodeStep flow={flow} />
        ) : (
          <SignUpStep flow={flow} destination={destination} />
        )}
      </div>
    </ArrivingLayout>
  );
}
